<ion-header>
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-back-button [parkourBackButton]="['../..']" />
    </ion-buttons>

    <ion-title>{{ 'team.uitnodiging-detail-page.title' | translate }}</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content>
  <ion-refresher [parkourRefresh]="onPageRefresh" slot="fixed">
    <ion-refresher-content></ion-refresher-content>
  </ion-refresher>

  <parkour-page-layout>
    <ng-container *parkourPageContent="mainPageData$ | async; refresh: onPageRefresh; let data">
      @switch (data.uitnodiging.status) {
        @case ('VERSTUURD') {
          <parkour-verzonden-detail
            (verwijderUitnodiging)="onVerwijderUitnodiging(data.uitnodiging.id)"
            [uitnodiging]="data.uitnodiging"
          />
        }
        @case ('AANVAARD') {
          <parkour-uitnodiging-aanvaard-detail
            (bevestigUitnodiging)="onBevestigUitnodiging(data.uitnodiging.id)"
            (verwijderUitnodiging)="onVerwijderUitnodiging(data.uitnodiging.id)"
            [uitnodiging]="data.uitnodiging"
          />
        }
        @case ('GEWEIGERD') {
          <parkour-verzonden-detail [uitnodiging]="data.uitnodiging" />
        }
        @case ('VERWIJDERD') {
          <parkour-error-component />
        }
        @case ('BEVESTIGD') {
          <parkour-uitnodiging-bevestigd-detail [uitnodiging]="data.uitnodiging" />
        }
      }
    </ng-container>
  </parkour-page-layout>
</ion-content>
